import { BaseEntity } from "./base-entity";
export class UserAccount extends BaseEntity {
  FirstName: string;
  LastName: string;
  Password: string;
  Email: string;
  Phone: string;
  DateOfBirth: Date;
  AddressLine1: string;
  AddressLine2: string;
  Gender: string;
  State: string;
  Zip: string;
  Country: string;
  City: string;
  UserRoleId: number;
  IsActive: boolean;
  IsPhoneVerified: boolean;
  IsFirstLogin: boolean;
  LastLoginTime: Date;
  SessionId: string;
  ProfilePictureId: number;
  ProfilePictureThumbId: number;
  ProfileUrl: string;
  ProfileThumbUrl: string;
  DeploymentId: number;
  LastLogoutTime: Date;
  PharmacyId: number;
  IsPharamcyAdmin: boolean;
  constructor() {
    super();
    this.FirstName = null;
    this.LastName = null;
    this.Password = null;
    this.Email = null;
    this.Phone = null;
    this.DateOfBirth = null;
    this.AddressLine1 = null;
    this.AddressLine2 = null;
    this.State = null;
    this.Zip = null;
    this.Country = "United States";
    this.IsActive = true;
    this.IsPhoneVerified = false;
    this.IsFirstLogin = false;
    this.LastLoginTime = null;
    this.SessionId = null;
    this.ProfilePictureId = null;
    this.ProfilePictureThumbId = null;
    this.ProfileUrl = null;
    this.ProfileThumbUrl = null;
    this.City = null;
    this.DeploymentId = 1;
    this.LastLoginTime = null;
    this.UserRoleId = null;
    this.PharmacyId = null;
    this.IsPharamcyAdmin = false;
    this.Gender = null;
    // this.ContractDocumentID = null;
  }
}
